import type { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'

interface IconProps {
  padding?: number
  inline?: boolean
  size?: number
  rotate?: number
  color?: string
  onClick?: (event: any) => void
}

interface IconComponentProps extends IconProps {
  children: ReactNode
  className?: string
}

const StyledSpan = styled.span<IconProps>`
  padding: ${(props) => `${props.padding}px`};
  display: ${(props) => (props.inline ? 'inline-flex' : 'flex')};
  svg {
    fill: ${(props) => props.color};
    width: ${(props) => `${props.size}px`};
    height: ${(props) => `${props.size}px`};
    transform: ${(props) => `rotate(${props.rotate}deg)`};
    path {
      fill: ${(props) => props.color};
    }
  }
`

const Icon: FunctionComponent<IconComponentProps> = ({
  children,
  padding = 0,
  inline,
  size = 16,
  rotate = 0,
  className,
  color,
  ...otherProps
}) => {
  return (
    <StyledSpan
      padding={padding}
      inline={inline}
      size={size}
      rotate={rotate}
      className={className}
      color={color}
      {...otherProps}
    >
      {children}
    </StyledSpan>
  )
}

export default Icon
